module.exports = __webpack_public_path__ + "static/media/gameoflifedie.f1fde299.png";